/* eslint-disable @typescript-eslint/no-explicit-any */
// Small wrapper for desktop event streams (Wails runtime)
export class BaseEventEmitter {
  private topic: string;
  private listeners: Set<(data: unknown) => void> = new Set();
  private runtimeHandler?: (data: unknown) => void;

  constructor(topic: string) {
    this.topic = topic;
  }

  addListener(cb: (data: unknown) => void) {
    this.listeners.add(cb);
    // attach runtime event if available
    if (typeof window !== 'undefined' && window.runtime?.EventsOn) {
      if (!this.runtimeHandler) {
        this.runtimeHandler = (d: unknown) => {
          this.listeners.forEach(l => {
            try {
              l(d);
            } catch {
              // ignore listener errors
            }
          });
        };
        window.runtime.EventsOn(this.topic, this.runtimeHandler);
      }
    }
  }

  remove() {
    // detach runtime event
    if (
      this.runtimeHandler &&
      typeof window !== 'undefined' &&
      window.runtime?.EventsOff
    ) {
      try {
        window.runtime.EventsOff(this.topic);
      } catch {
        // ignore
      }
    }
    this.listeners.clear();
  }
}

export async function subscribeAppEventsStream(
  topic: string,
): Promise<BaseEventEmitter> {
  const emitter = new BaseEventEmitter(topic);
  if (
    typeof window !== 'undefined' &&
    window.go?.main?.App?.SubscribeAppEventsStream
  ) {
    await window.go.main.App.SubscribeAppEventsStream(topic);
  }
  return emitter;
}

export async function subscribeOrderEventsStream(
  topic: string,
): Promise<BaseEventEmitter> {
  const emitter = new BaseEventEmitter(topic);
  // eslint-disable-next-line no-console
  console.log(
    '[LocalStreams] subscribeOrderEventsStream called for topic',
    topic,
  );
  if (
    typeof window !== 'undefined' &&
    window.go?.main?.App?.SubscribeOrderEventsStream
  ) {
    // call the bridge to register the stream on the Go side. The bridge
    // implementation will cause runtime events to be emitted for this topic.
    // We don't rely on the return value.
    await window.go.main.App.SubscribeOrderEventsStream(topic);
  }
  return emitter;
}
